/**
 * Replaces non-ASCII Latin letters with their closest ASCII equivalents.
 *
 * Printers that receive text (rather than a rendered bitmap) encode it with a
 * single-byte code page before handing it to the hardware:
 *   - Star  -> CP1252 / Windows-1252
 *   - Epson -> ANK character model
 *   - myPOS -> ASCII-only firmware font
 *
 * A character missing from that code page does not degrade gracefully: on Android
 * it becomes '?', and on iOS `dataUsingEncoding:` fails for the whole string, so the
 * entire text chunk is silently dropped from the receipt. Central/Eastern European
 * letters such as 'Ć' hit exactly this case, which is why a product name containing
 * one could disappear from the printout.
 *
 * Only apply this to printers with a byte-encoded text path. Sunmi and Adyen render
 * Unicode themselves and must keep the original spelling.
 */
export function replaceWithLatinSymbols(text: string): string {
  if (!text) {
    return text;
  }
  return text
    .replace(/[àáâãäåæāăą]/g, 'a')
    .replace(/[çćĉċč]/g, 'c')
    .replace(/[ðďđ]/g, 'd')
    .replace(/[èéêëēĕėęě]/g, 'e')
    .replace(/[ƒ]/g, 'f')
    .replace(/[ĝğġģ]/g, 'g')
    .replace(/[ĥħ]/g, 'h')
    .replace(/[ìíîïĩīĭįı]/g, 'i')
    .replace(/[ĵ]/g, 'j')
    .replace(/[ķĸ]/g, 'k')
    .replace(/[ĺļľŀł]/g, 'l')
    .replace(/[ñńņňŉŋ]/g, 'n')
    .replace(/[òóôõöøœōŏő]/g, 'o')
    .replace(/[ŕŗř]/g, 'r')
    .replace(/[śŝşšș]/g, 's')
    .replace(/[ţťŧț]/g, 't')
    .replace(/[ùúûüũūŭůűų]/g, 'u')
    .replace(/[ŵ]/g, 'w')
    .replace(/[ýþÿŷ]/g, 'y')
    .replace(/[žźż]/g, 'z')
    .replace(/[ÀÁÂÃÄÅÆĀĂĄ]/g, 'A')
    .replace(/[ÇĆĈĊČ]/g, 'C')
    .replace(/[ÐĎĐ]/g, 'D')
    .replace(/[ÈÉÊËĒĔĖĘĚ]/g, 'E')
    .replace(/[ĜĞĠĢ]/g, 'G')
    .replace(/[ĤĦ]/g, 'H')
    .replace(/[ÌÍÎÏĨĪĬĮİ]/g, 'I')
    .replace(/[Ĵ]/g, 'J')
    .replace(/[Ķ]/g, 'K')
    .replace(/[ĹĻĽĿŁ]/g, 'L')
    .replace(/[ÑŃŅŇŊ]/g, 'N')
    .replace(/[ÒÓÔÕÖØŒŌŎŐ]/g, 'O')
    .replace(/[ŔŖŘ]/g, 'R')
    .replace(/[ŚŜŞŠȘ]/g, 'S')
    .replace(/[ŢŤŦȚ]/g, 'T')
    .replace(/[ÙÚÛÜŨŪŬŮŰŲ]/g, 'U')
    .replace(/[Ŵ]/g, 'W')
    .replace(/[ÝŶŸ]/g, 'Y')
    .replace(/[ŽŹŻ]/g, 'Z')
    .replace(/ß/g, 'ss');
}
